export default "__VITE_ASSET__Ddmxo9FV__"